// html2canvas 는 캡처 시 문서를 숨은 iframe 에 클론하고 <link rel="stylesheet"> 의 CSS 를
// 네트워크에서 다시 요청한다. 배포 직후에는 옛 해시 CSS 파일이 서버에서 사라져 이 재요청이
// 404 → 클론이 무스타일로 캡처된다 (WEB-2272 — 화면은 이미 로드된 CSSOM 이라 정상으로 보임).
// 화면의 CSSOM 을 직렬화해 클론의 <link> 를 인라인 <style> 로 치환하면 클론이 네트워크
// 재요청 없이 화면과 동일하게 렌더된다. html2canvas 가 <style> 태그(Emotion insertRule)에
// 이미 쓰는 것과 같은 직렬화 기법.
// cross-origin 시트(cssRules 접근 불가)와 미로드 시트(sheet 없음)는 원래 링크를 유지한다.

// 해시 파일명(href)은 내용 불변이므로 직렬화 결과를 모듈 캐시해 섹션별 반복 캡처 비용을 줄인다.
const cssTextByHref = new Map<string, string>()

export function inlineStylesheetsIntoClone(clonedDoc: Document) {
  // 어떤 이유로든 실패하면 치환 없이 기존 동작(링크 유지)으로 폴백 —
  // onclone 에서 예외가 새면 export 자체가 실패하므로 fail-open 이 안전하다.
  try {
    const inlined = new Map<string, string>()

    Array.from(document.styleSheets).forEach((sheet) => {
      const node = sheet.ownerNode
      if (!(node instanceof HTMLLinkElement) || !node.href) {
        return
      }

      const cached = cssTextByHref.get(node.href)
      if (cached != null) {
        inlined.set(node.href, cached)

        return
      }

      try {
        const cssText = Array.from(sheet.cssRules)
          .map((rule) => rule.cssText)
          .join("\n")
        cssTextByHref.set(node.href, cssText)
        inlined.set(node.href, cssText)
      } catch {
        // cross-origin 시트 — cssRules 접근 불가, 링크 유지
      }
    })

    clonedDoc.querySelectorAll<HTMLLinkElement>('link[rel="stylesheet"]').forEach((link) => {
      const cssText = inlined.get(link.href)
      if (cssText == null) {
        return
      }

      const style = clonedDoc.createElement("style")
      style.textContent = cssText
      if (link.media) {
        style.media = link.media
      }
      link.replaceWith(style)
    })
  } catch {
    // 폴백: 클론은 기존처럼 <link> 로 CSS 를 로드한다
  }
}
